import React from 'react'
import {render} from 'react-dom'
import {Provider} from 'react-redux'
import App from './containers/App'
import LoginPage from './components/LoginPage'
import PasswordResetPage from './components/PasswordResetPage'
import PasswordChangePage from './components/PasswordChangePage'
import 'font-awesome-webpack';
import 'bootstrap';
//import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/bootstrap-lumen.css'
import './styles/bootstrap-lumen-mods.css'
import './styles/app.css'
import './styles/forms.css';
import configureStore from './store/configureStore'
import {ConnectedRouter} from 'react-router-redux'
import 'whatwg-fetch'
import {Route} from 'react-router'
import {sessionService} from 'redux-react-session';
import {initialize, addTranslation} from 'react-localize-redux';

const {store, history} = configureStore();

// init localization
store.dispatch(initialize(['fi', 'en', 'se'], { defaultLanguage: 'fi' }));
store.dispatch(addTranslation(require('../data/global.locale.json')));

console.log('Initializing session service');

sessionService.initSessionService(store, { driver: 'COOKIES' });

console.log('Session service initialized');

render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <div>
                <Route exact path='/' component={App}/>
                <Route path='/login' component={LoginPage}/>
                <Route path='/reset-password' component={PasswordResetPage}/>
                <Route path='/change-password' component={PasswordChangePage}/>
            </div>
        </ConnectedRouter>
    </Provider>,
    document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js